import React from 'react';
import classNames from 'classnames';
import css from './Label.module.css';

/**
 * Custom Label component matching shadcn/ui design
 * Built with vanilla React + CSS Modules
 */
export const Label = ({
  children,
  htmlFor,
  className,
  ...props
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={classNames(css.label, className)}
      {...props}
    >
      {children}
    </label>
  );
};

// Support both default and named imports
export default Label;
